import { provideTooltip } from '@ui';

export const TOOLTIP_PROVIDER = provideTooltip();
